export default __webpack_public_path__ + "static/media/cars-driving-parking-house-office-animation.82dfbdd5.gif";